export type FrontPage = "feestzaal" | "kersen";

/**
 * Which page is served at the root URL "/".
 * Switch between 'feestzaal' (BanquetHall) and 'kersen' (Cherries)
 * to change the front page across the router and header navigation.
 */
export const FRONT_PAGE: FrontPage = "feestzaal";

/**
 * Returns the extra paths that should highlight a nav item as active.
 * The nav item matching FRONT_PAGE also owns the root "/" path.
 */
export const homePaths = (page: FrontPage): string[] =>
  FRONT_PAGE === page ? ["/"] : [];

/**
 * The cherry season runs through distinct phases across the year.
 * Switch CHERRY_PHASE to change the text shown on the Cherries page,
 * and whether the order form + opening hours are visible.
 *
 *  - 'recruiting' : before the season, announcing we're hiring students/flexi-jobbers
 *  - 'preseason'  : ~a month before, announcing the upcoming season (no form yet)
 *  - 'preorder'   : ~a week before opening, the order form is shown but ordering/pickup starts on a future date
 *  - 'active'     : during the season, the order form + opening hours are shown
 *  - 'paused'     : season started but new orders are temporarily paused — the notice + order form show (for upcoming dates with stock), opening hours hidden
 *  - 'closing'    : final pick weekend — thanks customers, no free sale or new orders; opening hours stay visible for pickups
 *  - 'closed'     : after the season, thanking customers for their purchases
 */
export type CherryPhase =
  | "recruiting"
  | "preseason"
  | "preorder"
  | "active"
  | "paused"
  | "closing"
  | "closed";

export const CHERRY_PHASE: CherryPhase = "closed";
